var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTornillos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 631,
    viewBox: "0 0 23 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4943 16.5464C22.199 15.1382 22.9036 13.3779 22.9036 11.2656C22.9036 4.92871 17.9709 0 11.6288 0C9.86713 0 8.10544 0.352051 6.34375 1.4082L21.4943 16.5464Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76169 5.62891C0.704676 7.38916 0 9.14942 0 11.2617C0 17.5986 4.93273 22.5273 11.2748 22.5273C13.3888 22.5273 15.1505 21.8232 16.9122 20.7671L1.76169 5.62891Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4943 624.546C22.199 623.138 22.9036 621.378 22.9036 619.266C22.9036 612.929 17.9709 608 11.6288 608C9.86713 608 8.10544 608.352 6.34375 609.408L21.4943 624.546Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76169 613.629C0.704676 615.389 0 617.149 0 619.262C0 625.599 4.93273 630.527 11.2748 630.527C13.3888 630.527 15.1505 629.823 16.9122 628.767L1.76169 613.629Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4943 315.546C22.199 314.138 22.9036 312.378 22.9036 310.266C22.9036 303.929 17.9709 299 11.6288 299C9.86713 299 8.10544 299.352 6.34375 300.408L21.4943 315.546Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76169 304.629C0.704676 306.389 0 308.149 0 310.262C0 316.599 4.93273 321.527 11.2748 321.527C13.3888 321.527 15.1505 320.823 16.9122 319.767L1.76169 304.629Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornillos);
export default __webpack_public_path__ + "static/media/tornillos.c882ba026a22b17d7153033117a164d2.svg";
export { ForwardRef as ReactComponent };